import * as React from 'react';

function SvgAlignRight(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="align-right_svg__feather align-right_svg__feather-align-right"
      {...props}
    >
      <path d="M21 10H7M21 6H3M21 14H3M21 18H7" />
    </svg>
  );
}

export default SvgAlignRight;
